import e from "react";
import { Box as a, Tab as n, Typography as i } from "@mui/material";
import { TabContext as l, TabList as c, TabPanel as m } from "@mui/lab";
import { s as o } from "./styled-38387a7e.js";
import "./createTheme-02ce03eb.js";
import "@emotion/styled";
import "@emotion/react";
const E = o(b)(() => ({}));
function b(t) {
  return /* @__PURE__ */ e.createElement(l, { ...t });
}
const h = o(u)(({ theme: t }) => ({
  "& .MuiTabs-indicator": {
    height: 4,
    backgroundColor: t.palette.blue.c100
  }
}));
function u(t) {
  return /* @__PURE__ */ e.createElement(a, { sx: { borderBottom: 1, borderColor: "blue.c20" } }, /* @__PURE__ */ e.createElement(c, { ...t }));
}
const y = o(s)(({ theme: t }) => ({
  color: t.palette.darkBlue.c50,
  textTransform: "inherit",
  padding: "0",
  marginRight: "40px",
  "&.Mui-selected": {
    color: t.palette.blue.c100
  }
}));
function s({ label: t, ...r }) {
  return /* @__PURE__ */ e.createElement(n, { label: /* @__PURE__ */ e.createElement(i, { variant: "body2M" }, t), ...r });
}
const z = o(p)(() => ({
  padding: "40px 0"
}));
function p(t) {
  return /* @__PURE__ */ e.createElement(m, { ...t });
}
export {
  y as MzTab,
  E as MzTabContext,
  h as MzTabList,
  z as MzTabPanel
};
